import(/* webpackMode: "eager" */ "/rishi-s-gay/app/globals.css");
import(/* webpackMode: "eager" */ "/rishi-s-gay/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/rishi-s-gay/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/rishi-s-gay/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/rishi-s-gay/components/ui/tooltip.tsx")